import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import RemoveIcon from "@mui/icons-material/RemoveCircle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { useState } from "react";
import InPlaceConfirmation from "../InPlaceConfirmation";

const getSegmentFlightDateTime = ({ dD, dT }) =>
  dD ? `${dD}${dT ? "T" + dT + ":00" : "T00:00:00"}` : new Date().toISOString();

const EditItinerarySegment = ({ segment, ...props }) => {
  const [remove, setRemove] = useState(false);

  const onCancelSegmentRemove = () => {
    setRemove(false);
  };

  const onConfirmSegmentRemove = () => {
    setRemove(false);
    props.onRemove(segment.id);
  };

  const onChange = (field) => (event) => {
    const newValue = event.target.value;
    if (
      (field === "c" && newValue.length <= 1) ||
      (["d", "o"].some((f) => f === field) && newValue.length <= 3)
    ) {
      props.onChange({ ...segment, [field]: newValue.toUpperCase() });
    }
  };

  const onFlightDateTimeChange = (value) => {
    props.onChange({
      ...segment,
      dD: value.format("YYYY-MM-DD"),
      dT: value.format("HH:mm"),
    });
  };

  return (
    <InPlaceConfirmation
      component={Grid}
      container
      onCancel={onCancelSegmentRemove}
      onConfirm={onConfirmSegmentRemove}
      open={remove}
    >
      <Grid container xs={10}>
        <Grid xs={4.5}>
          <TextField
            label="Origin"
            onChange={onChange("o")}
            required
            value={segment.o}
          />
        </Grid>
        <Grid xs={4.5}>
          <TextField
            label="Destination"
            onChange={onChange("d")}
            required
            value={segment.d}
          />
        </Grid>
        <Grid xs={3}>
          <TextField
            label="Class"
            onChange={onChange("c")}
            value={segment.c || ""}
          />
        </Grid>
        <Grid xs={12}>
          <DateTimePicker
            ampm={false}
            format="DD-MMM-YYYY HH:mm"
            label="Flight DateTime"
            onAccept={onFlightDateTimeChange}
            slots={{
              openPickerIcon: FlightTakeoffIcon,
            }}
            slotProps={{ textField: { fullWidth: true } }}
            value={segment.dD ? dayjs(getSegmentFlightDateTime(segment)) : null}
          />
        </Grid>
      </Grid>
      <Grid xs={2} display="flex" justifyContent="center">
        <IconButton
          onClick={() => setRemove(true)}
          disableRipple
          title="Remove Segment"
        >
          <RemoveIcon />
        </IconButton>
      </Grid>
    </InPlaceConfirmation>
  );
};

export default EditItinerarySegment;
